import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      paddingTop: 0,
    },
  },
  form: {
    marginTop: theme.spacing(3),
  },
  switchBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('mobile')]: {
      marginTop: 'unset',
      width: '30%',
    },
  },
}));



// WEBPACK FOOTER //
// ./src/components/LoanOfficerSettings/components/AutoFollowupsMessages/useStyles.js